import { Button, CheckboxFormField, ClassName, Form, IFormRender, Theme } from '@busybusy/webapp-react-ui';
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { useToastDispatch } from 'contexts/ToastContext';
import { usePositionUpdate } from 'hooks';
import { t } from 'i18next';
import IPosition from 'types/Position';

export interface IRequestTimeOffSettingsFormProps {
  className?: ClassName;
  position: IPosition;
  onSubmit: (data: { enabled: boolean }) => void;
}

export interface IRequestTimeOffSettingsFormData {
  enabled: boolean;
}

export const RequestTimeOffSettingsForm = (props: IRequestTimeOffSettingsFormProps) => {
  const { className, position, onSubmit } = props;

  const [, update] = usePositionUpdate();
  const toastDispatch = useToastDispatch();

  async function onFormSubmit(data: IRequestTimeOffSettingsFormData) {
    try {
      await update({
        id: position.id,
        canRequestTimeOff: data.enabled,
      });
    } catch (e) {
      toastDispatch({
        type: 'OPEN',
        payload: {
          theme: Theme.DANGER,
          label: t('There was a problem updating your position. Please try again later.'),
        },
      });
    }

    onSubmit(data);
  }

  function renderFormFields(form: IFormRender<IRequestTimeOffSettingsFormData>) {
    return (
      <>
        <CheckboxFormField
          key={'enabled'}
          name={'enabled'}
          form={form}
          label={
            <HeaderText title={t('Request Time Off')}>
              <span>{t('Can add, edit, and remove time off requests for self.')}</span>
            </HeaderText>
          }
        />
        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  return (
    <Form
      className={className}
      render={renderFormFields}
      onSubmit={onFormSubmit}
      data={{ enabled: !!position.canRequestTimeOff }}
      allowMultipleSubmissions={true}
    />
  );
};
